import React from 'react';
import PropTypes from 'prop-types';
import GetPlanData from 'app/utility/GetPlanData.js';

class PromoDefault extends React.Component {
    render() {
        return (
            <div className="no-promo">
                {this.props.image ? (
                    this.props.image
                ) : null}
                <h1 className="promo-copy">
                    {this.props.main}
                </h1>
                {this.props.subCopy ? (
                    <div className="sub-copy">
                        {this.props.subCopy}
                    </div>
                ) : null}
                <button type="button" className="promo-action-button" onClick={this.props.buttonAction}>
                    {this.props.buttonLabel}
                </button>
                {this.props.help ? (
                     <div className="promo-help">
                        {this.props.help}
                    </div>
                ) : null }
            </div>
        );
    }
}

PromoDefault.displayName = "PromoDefault";

PromoDefault.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ]),
    main: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
    subCopy: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object
    ]),
    buttonLabel: PropTypes.string,
    buttonAction: PropTypes.func,
    help: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string
    ])
};

PromoDefault.defaultProps = {
    image: null,
    main: "",
    subCopy: null,
    buttonLabel: "",
    buttonAction: () => {},
    help: null
};

export default PromoDefault;
